import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IOrthodonticReferralAttachmentCategory, ISaveIOrthodonticReferral, IOrthodonticReferral, IOrthodonticReferralUploadFileAsConsultantModel } from "../models/IOrthodonticReferral";
import { objectToQueryString } from "../helpers/ApiHelper";

export class OrthodonticReferralAdministrationApi extends ApiClient {

    constructor(auth: AuthContextModel) {
        super(auth);
    }

    sendOrthodonticReferral(data: ISaveIOrthodonticReferral, success: (orthodonticReferralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/send`, data, success, error, final);
    }

    saveOrthodonticReferral(data: ISaveIOrthodonticReferral, success: (orthodonticReferralId: number) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/save`, data, success, error, final);
    }

    withdrawOrthodonticReferral(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/withdraw/${orthodonticReferralId}`, undefined, success, error, final);
    }

    getOrthodonticReferralAttachmentCategories(success: (data: IOrthodonticReferralAttachmentCategory[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<IOrthodonticReferralAttachmentCategory[]>(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/attachmentCategories`, success, error, final);
    }

    removeOrthodonticReferralAttachment(attachmentId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/removeAttachment/${attachmentId}`, success, error, final);
    }

    confirmPatientViewing(orthodonticReferralPatientViewingId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/confirmPatientViewing/${orthodonticReferralPatientViewingId}`, undefined, success, error, final);
    }

    markAnswerAsRead(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/markAnswerAsRead/${orthodonticReferralId}`, undefined, success, error, final);
    }

    shareReferral(orthodonticReferralId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/share/${orthodonticReferralId}`, undefined, success, error, final);
    }
    copyOrthodonticReferral(orthodonticReferralId: number, success: (copiedData: IOrthodonticReferral) => void, error?: (message: string) => void, final?: () => void) {
        this.postWithResponse(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/copy/${orthodonticReferralId}`, undefined, success, error, final);
    }

    deleteOrthodonticReferral(orthodonticReferralId: string, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/deleteOrthodonticReferral/${orthodonticReferralId}`, success, error, final);
    }

    extendValidDate(orthodonticReferralId: number, extendedDate: Date, success: () => void, error?: (message: string) => void, final?: () => void) {
        const queryString = objectToQueryString({ orthodonticReferralId: orthodonticReferralId, extendedDate: extendedDate });
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/extendValidDate?${queryString}`, undefined, success, error, final);
    }

    uploadFilesAsConsultan(data: IOrthodonticReferralUploadFileAsConsultantModel, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/orthodonticReferralAdministration/uploadFilesAsConsultant`, data, success, error, final);
    }
}